export class Pagination {
  count: number;
  total: number;
  current_page: number;
  per_page: number;
  total_pages: number;
}
